import { AuthConfig } from "angular-oauth2-oidc";

export const environment = {
  production: false,
  apiUrl: 'https://time-test.iowa.uiowa.edu/api/',
  loadDiscoveryDoc: false,
  spinnerDelay: 400,
  tsAutoSaveDelay: 3000
};

export const OAuthConfig: AuthConfig = {
  clientId: "its-time-tracker-test-173E3A32ABE04CC89E556D339C907A36",
  scope: "openid profile uiowa.identifiers offline_access",
  responseType: 'code',
  redirectUri: "https://time-test.iowa.uiowa.edu",
  clearHashAfterLogin: true,

  // The IDP does not return an id token during a token refresh. Without disabling the timer here, this
  // leads to an infinite token refresh loop. This is the solution prescribed by the library author.
  disableIdTokenTimer: true, 

  issuer: "https://idp-test.uiowa.edu",
  tokenEndpoint: "https://idp-test.uiowa.edu/idp/profile/oidc/token",
  loginUrl: "https://idp-test.uiowa.edu/idp/profile/oidc/authorize",
  logoutUrl: "https://idp-test.uiowa.edu/idp/profile/Logout",
  userinfoEndpoint: "https://idp-test.uiowa.edu/idp/profile/oidc/userinfo"
}
